import React, { useState } from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaPaperPlane,
} from "react-icons/fa";
import { sendHtmlEmail } from "../emailapi";
const ContactWithForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    await sendHtmlEmail("shardaiti2014@gmail.com", "New Enquiry", formData);

    alert("Thank you for reaching out! We'll get back to you soon.");
    setFormData({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <section className="w-full overflow-hidden bg-gradient-to-br from-green-50 via-white to-orange-50 py-16 md:py-24">
      <div className="w-full px-0">
        <div className="mx-auto mb-12 max-w-4xl px-4 text-center sm:px-6 lg:px-8">
          <h2 className="text-3xl font-extrabold text-gray-900 md:text-4xl">
            Get in <span className="text-green-600">Touch</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-gray-600 md:text-lg">
            We’d love to hear from you. Send us a message and we’ll respond as
            soon as possible.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-0 md:grid-cols-2">
          <div className="bg-white/80 p-8 shadow-lg md:p-10">
            <h3 className="mb-6 text-2xl font-bold text-gray-800">Contact Details</h3>
            <div className="space-y-6">
              <div className="group flex items-start gap-4 transition-transform hover:translate-x-2">
                <div className="rounded-full bg-green-100 p-3 text-green-600">
                  <FaMapMarkerAlt className="h-6 w-6" />
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800">Address</h4>
                  <p className="text-gray-600">
                    Village - Kushnow, Post - Bhaupur
                    <br />
                    District - Jaunpur
                    <br />
                    Pin - 222136 (Uttar Pradesh)
                  </p>
                </div>
              </div>
              <div className="group flex items-start gap-4 transition-transform hover:translate-x-2">
                <div className="rounded-full bg-orange-100 p-3 text-orange-500">
                  <FaPhoneAlt className="h-6 w-6" />
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800">Call Us</h4>
                  <p className="text-gray-600">
                    +91 9956808612
                    <br />
                    +91 8090586416
                  </p>
                </div>
              </div>
              <div className="group flex items-start gap-4 transition-transform hover:translate-x-2">
                <div className="rounded-full bg-green-100 p-3 text-green-600">
                  <FaEnvelope className="h-6 w-6" />
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800">Email</h4>
                  <p className="break-all text-gray-600">shardaiti2014@gmail.com</p>
                </div>
              </div>
              <div className="group flex items-start gap-4 transition-transform hover:translate-x-2">
                <div className="rounded-full bg-orange-100 p-3 text-orange-500">
                  <FaClock className="h-6 w-6" />
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-800">Working Hours</h4>
                  <p className="text-gray-600">
                    Monday – Saturday: 9:00 AM – 6:00 PM
                    <br />
                    Sunday: Closed
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white/60 p-8 shadow-lg backdrop-blur-sm md:p-10">
            <h3 className="mb-6 text-2xl font-bold text-gray-800">Send a Message</h3>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label htmlFor="name" className="mb-1 block text-sm font-medium text-gray-700">
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-green-500 focus:outline-none focus:ring-2 focus:ring-green-200"
                />
              </div>
              <div>
                <label htmlFor="email" className="mb-1 block text-sm font-medium text-gray-700">
                  Email Address *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-green-500 focus:outline-none focus:ring-2 focus:ring-green-200"
                />
              </div>
              <div>
                <label htmlFor="phone" className="mb-1 block text-sm font-medium text-gray-700">
                  Phone Number
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-green-500 focus:outline-none focus:ring-2 focus:ring-green-200"
                />
              </div>
              <div>
                <label htmlFor="message" className="mb-1 block text-sm font-medium text-gray-700">
                  Message *
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-green-500 focus:outline-none focus:ring-2 focus:ring-green-200"
                />
              </div>
              <button
                type="submit"
                className="group inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-green-600 to-orange-500 px-6 py-2.5 font-semibold text-white shadow-md transition-all hover:shadow-lg"
              >
                Send Message
                <FaPaperPlane className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </button>
            </form>
          </div>
        </div>
        <div className="mt-12 w-full">
          <div className="animate-fadeInUp overflow-hidden rounded-none shadow-lg">
            <iframe
              title="Location Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28676.913710979653!2d82.682943!3d25.751876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39918d9b8b1b6b6b%3A0x6c2b8c5a5b5b5b5b!2sJaunpur%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1699876543210!5m2!1sen!2sin"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="transition-all duration-500 hover:scale-105"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactWithForm;